import { render, staticRenderFns } from "./SetPasswordScreen.vue?vue&type=template&id=6eba8b01&scoped=true"
import script from "./SetPasswordScreen.vue?vue&type=script&lang=js"
export * from "./SetPasswordScreen.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordScreen.vue?vue&type=style&index=0&id=6eba8b01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba8b01",
  null
  
)

export default component.exports